export const normalizeEscapedNewlines = (value: unknown): string => {
  return String(value ?? '')
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n(?=\s|[-*•+\dA-ZÀ-Ỹ])/g, '\n')
    .replace(/\\r(?=\s|[-*•+\dA-ZÀ-Ỹ])/g, '\n')
    .replace(/\\t(?=\s|[-*•+\dA-ZÀ-Ỹ])/g, '\t');
};
